'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AdyenCardComponent = require('./AdyenCardComponent');

var _AdyenCardComponent2 = _interopRequireDefault(_AdyenCardComponent);

var _AdyenPayPalComponent = require('./AdyenPayPalComponent');

var _AdyenPayPalComponent2 = _interopRequireDefault(_AdyenPayPalComponent);

var _AdyenIdealComponent = require('./AdyenIdealComponent');

var _AdyenIdealComponent2 = _interopRequireDefault(_AdyenIdealComponent);

var _AdyenBcmcComponent = require('./AdyenBcmcComponent');

var _AdyenBcmcComponent2 = _interopRequireDefault(_AdyenBcmcComponent);

var _AdyenBcmcMobileComponent = require('./AdyenBcmcMobileComponent');

var _AdyenBcmcMobileComponent2 = _interopRequireDefault(_AdyenBcmcMobileComponent);

var _AdyenKlarnaComponent = require('./AdyenKlarnaComponent');

var _AdyenKlarnaComponent2 = _interopRequireDefault(_AdyenKlarnaComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentOption = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(PaymentOption, _React$Component);

  function PaymentOption() {
    (0, _classCallCheck3.default)(this, PaymentOption);
    return (0, _possibleConstructorReturn3.default)(this, (PaymentOption.__proto__ || (0, _getPrototypeOf2.default)(PaymentOption)).apply(this, arguments));
  }

  (0, _createClass3.default)(PaymentOption, [{
    key: 'render',
    value: function render() {
      var paymentMethod = this.props.paymentMethod;
      var type = paymentMethod.type;


      switch (type) {
        case 'scheme':
          console.log('rendering payment option: ' + type, paymentMethod);
          return _react2.default.createElement(_AdyenCardComponent2.default, this.props);
        case 'paypal':
          console.log('rendering payment option: ' + type, paymentMethod);
          return _react2.default.createElement(_AdyenPayPalComponent2.default, this.props);
        case 'ideal':
          console.log('rendering payment option: ' + type, paymentMethod);
          return _react2.default.createElement(_AdyenIdealComponent2.default, this.props);
        case 'bcmc':
          console.log('rendering payment option: ' + type, paymentMethod);
          return _react2.default.createElement(_AdyenBcmcComponent2.default, this.props);
        case 'bcmc_mobile':
          console.log('rendering payment option: ' + type, paymentMethod);
          return _react2.default.createElement(_AdyenBcmcMobileComponent2.default, this.props);
        case 'klarna':
        case 'klarna_paynow':
        case 'klarna_account':
          console.log('rendering payment option: ' + type, paymentMethod);
          return _react2.default.createElement(_AdyenKlarnaComponent2.default, this.props);
        case 'applepay':
        case 'paywithgoogle':
        default:
          console.warn('payment option not implemented: ' + type, paymentMethod);
          return null;
      }
    }
  }]);
  return PaymentOption;
}(_react2.default.Component), _class.propTypes = {
  selectable: _react.PropTypes.bool,
  paymentMethod: _react.PropTypes.object.isRequired,
  paymentMethodId: _react.PropTypes.number,
  active: _react.PropTypes.bool,
  onPaymentSelect: _react.PropTypes.func,
  order: _react.PropTypes.object.isRequired,
  params: _react.PropTypes.object,
  setCheckoutFormSubmitter: _react.PropTypes.func,
  dispatch: _react.PropTypes.func,
  setPaymentError: _react.PropTypes.func
}, _class.defaultProps = {
  selectable: true,
  onPaymentSelect: function onPaymentSelect() {}
}, _temp);
exports.default = PaymentOption;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/PaymentOption/index.js
// module id = 2492
// module chunks = 0